
import React from 'react';

import TextField from '../../../../forms/TextField';

export default function Mimes() {
  return(
    <TextField
      name="videoAd.mimes"
      label="Mimes (Comma Separated)"
    />
  )
}
